import { useEffect, useState } from "react";
import { User } from "@supabase/supabase-js";
import { supabase } from "@/integrations/supabase/client";

/**
 * Returns whether the current user is a Project Manager (role = "Manager")
 * with the tm_addsubtaskandstep__project_manager permission enabled for
 * their company in project_access_permissions.
 */
export const useTaskManagementSubtaskAccess = (user: User | null) => {
  const [role, setRole] = useState<string | null>(null);
  const [canManagerAddSubtasks, setCanManagerAddSubtasks] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const run = async () => {
      if (!user?.email) {
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        const { data: userRow } = await supabase
          .from("users")
          .select("role, company_name")
          .eq("email", user.email)
          .maybeSingle();

        const r = (userRow?.role || "").trim();
        const company = userRow?.company_name ?? null;
        setRole(r || null);

        if (r !== "Manager" || !company) {
          setCanManagerAddSubtasks(false);
          return;
        }

        const { data: permRow } = await supabase
          .from("project_access_permissions")
          .select("tm_addsubtaskandstep__project_manager")
          .eq("company_name", company)
          .maybeSingle();

        setCanManagerAddSubtasks(
          !!permRow && (permRow as any).tm_addsubtaskandstep__project_manager === true
        );
      } catch (e) {
        console.error("useTaskManagementSubtaskAccess error", e);
        setCanManagerAddSubtasks(false);
      } finally {
        setLoading(false);
      }
    };
    run();
  }, [user?.email]);

  return { role, canManagerAddSubtasks, loading };
};
